export const testimonials = [
  {
    name: "Rachel Thompson",
    role: "Speech-Language Pathologist",
    country: "United States",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/7b842cd1-1fa2-408a-8936-618a9cce42ee.jpg",
    quote:
      "I used to rebuild choice boards for every new student. Now I start from the Volume 3 templates and adapt them in a fraction of the time. The observation worksheets have also made my session notes much more consistent.",
  },
  {
    name: "Marcus Bennett",
    role: "Special Education Teacher",
    country: "United Kingdom",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/565c78d5-879d-4042-afb4-e64482473f8d.jpg",
    quote:
      "What I appreciated most was the respect for each child’s communication style. The classroom participation worksheets helped me plan opportunities during transitions and group work — not just during one-on-one time.",
  },
  {
    name: "Priya Raman",
    role: "AAC Specialist",
    country: "Canada",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/a752ad26-78db-4141-9dcc-db002216cdcc.jpg",
    quote:
      "The AAC personalization templates gave our team a shared language. Families, teachers, and I now walk into planning meetings looking at the same organized information.",
  },
  {
    name: "Helen Clarke",
    role: "Early Intervention Specialist",
    country: "Australia",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/82a3e926-95d4-461e-b7df-a145f275d3ab.jpg",
    quote:
      "Home visits move fast. Having the routine planners and family discussion guides ready means I can focus on the child and the parents instead of hunting for paperwork.",
  },
  {
    name: "Daniel Reyes",
    role: "Elementary School Teacher",
    country: "Ireland",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/97dd8b16-577c-4e0c-9181-103118cb75ce.jpg",
    quote:
      "The mealtime and playtime boards in the bonus library were exactly what my classroom needed. Clear, adaptable, and easy to print and personalize for each student.",
  },
];
